import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaGoogle, FaApple, FaFacebookF } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import authImg from "../Ui/dialogImage.png";
import { useTheme, useMediaQuery } from "@mui/material";
import { toast } from "react-toastify";
import Styledialog from "./dialog.module.css";
import { GiCheckMark } from "react-icons/gi";

const DialogBox = ({ open, handleClose, mode, switchMode }) => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const [isAdminMode, setIsAdminMode] = useState(false);
  const [adminKey, setAdminKey] = useState("");
  const ADMIN_EMAIL = "admin@gmail.com";
  const ADMIN_PASSWORD = "admin123";
  const ADMIN_KEY = "admin";

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = credentials;

    try {
      if (mode === "join") {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        console.log("User registered:", userCredential.user);
        toast.success("Registration successful! Please sign in...");

        await auth.signOut();

        setTimeout(() => {
          switchMode("signin");
          setCredentials({ email, password: "" });
        }, 1500);
      } else {
        if (isAdminMode) {
          if (
            adminKey !== ADMIN_KEY ||
            email !== ADMIN_EMAIL ||
            password !== ADMIN_PASSWORD
          ) {
            toast.warning("Incorrect Admin Credentials");
            return;
          }

          // Admin is verified
          toast.success("Admin login successful!");
          setTimeout(() => {
            handleClose();
            navigate("/admin/*/dashboard");
          }, 1500);
          return;
        }

        const userCredential = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        toast.success("Login successful!");

        setTimeout(() => {
          handleClose();
        }, 1500);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
      console.log(error);
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AnimatePresence>
      {open && (
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="md"
          fullWidth
          disableScrollLock
          fullScreen={isMobile}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: -30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: -30 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <DialogContent
              sx={{ display: "flex", padding: 0 }}
              className={Styledialog.maincontainer}
            >
              {/* LEFT PANEL */}
              <Box className={Styledialog.leftpanel}>
                <div className={Styledialog.leftpanelContent}>
                  <Typography variant="h4" fontWeight={500} gutterBottom>
                    Your Health, Our Priority
                  </Typography>
                  <ul className={Styledialog.leftpanelList}>
                    <li>
                      <GiCheckMark color="green" /> Access expert doctors across
                      specialties
                    </li>
                    <li>
                      <GiCheckMark color="green" /> Book appointments quickly
                      and securely
                    </li>
                    <li>
                      <GiCheckMark color="green" /> Manage your health records
                      in one place
                    </li>
                  </ul>
                </div>

                <img
                  src={authImg}
                  alt="auth visual"
                  className={Styledialog.authImage}
                />
              </Box>

              {/* RIGHT PANEL */}
              <Box
                sx={{
                  flex: 1,
                  padding: "2rem",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <IconButton
                  sx={{ position: "absolute", top: 10, right: 10 }}
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>

                <Typography variant="h5" fontWeight={600} gutterBottom>
                  {isAdminMode
                    ? "Admin Sign In"
                    : mode === "join"
                    ? "Create a new account"
                    : "Sign in to your account"}
                </Typography>

                <Typography variant="body2" gutterBottom>
                  {mode === "join" ? (
                    <>
                      Already have an account?{" "}
                      <span
                        style={{ color: "#1976d2", cursor: "pointer" }}
                        onClick={() => switchMode("signin")}
                      >
                        Sign in here
                      </span>
                    </>
                  ) : (
                    <>
                      Don’t have an account?{" "}
                      <span
                        style={{ color: "#1976d2", cursor: "pointer" }}
                        onClick={() => switchMode("join")}
                      >
                        Join here
                      </span>
                    </>
                  )}
                </Typography>

                {/* FORM */}
                <form onSubmit={handleSubmit} style={{ marginTop: "1rem" }}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Email or Username"
                    variant="outlined"
                    name="email"
                    value={credentials.email}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MdEmail />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div className={Styledialog.inputrow}>
                    {isAdminMode && (
                      <TextField
                        fullWidth
                        margin="normal"
                        label="Admin Access Key"
                        variant="outlined"
                        name="adminKey"
                        type="password"
                        value={adminKey}
                        onChange={(e) => setAdminKey(e.target.value)}
                      />
                    )}

                    <TextField
                      fullWidth
                      margin="normal"
                      label="Password"
                      variant="outlined"
                      name="password"
                      type="password"
                      value={credentials.password}
                      onChange={handleChange}
                    />
                  </div>

                  <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    sx={{ marginTop: "1rem" }}
                  >
                    {mode === "join" ? "Join Now" : "Sign In"}
                  </Button>
                </form>

                <Typography
                  variant="body2"
                  sx={{ mt: 1, cursor: "pointer", color: "#1976d2" }}
                  onClick={() => setIsAdminMode((prev) => !prev)}
                >
                  {mode === "signin"
                    ? isAdminMode
                      ? "Switch to User Sign In"
                      : "Sign in as Admin"
                    : ""}
                </Typography>

                {/* SOCIAL OPTIONS */}
                <Box sx={{ textAlign: "center", marginTop: "1.5rem" }}>
                  <Typography variant="body2">or</Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 2,
                      mt: { xs: 1, sm: 2 },
                    }}
                  >
                    <IconButton>
                      <FaGoogle />
                    </IconButton>
                    <IconButton>
                      <FaApple />
                    </IconButton>
                    <IconButton>
                      <FaFacebookF />
                    </IconButton>
                  </Box>
                </Box>

                <Typography variant="caption" className={Styledialog.buttons}>
                  By joining, you agree to the{" "}
                  <button
                    className={Styledialog.button}
                    type="button"
                    onClick={() => console.log("Show Terms of Service")}
                  >
                    Terms of Service
                  </button>{" "}
                  and{" "}
                  <button
                    className={Styledialog.button}
                    type="button"
                    onClick={() => console.log("Show Privacy Policy")}
                  >
                    Privacy Policy
                  </button>
                  .
                </Typography>
              </Box>
            </DialogContent>
          </motion.div>
        </Dialog>
      )}
    </AnimatePresence>
  );
};

export default DialogBox;
